createTransitionManager